import {
  Settings,
  Briefcase,
  Target,
  Zap,
  AlertCircle,
  BookOpen,
  Mail,
  FileText,
  Flame,
  GitBranch,
  HandCoins,
  ShieldCheck,
  Users,
} from 'lucide-react';

// ROLE_IDS: SUPER_ADMIN = 1, BUILDER = 2, USER = 3
export const MenuItems = [
  {
    title: 'Portfolio',
    icon: Briefcase,
    url: '/portfolio',
    permission: 'portfolio.view',
  },
  {
    title: 'Case Studies',
    icon: BookOpen,
    url: '/case-studies',
    permission: 'case_studies.view',
  },
  {
    title: 'Blogs',
    icon: FileText,
    url: '/blogs',
    permission: 'blogs.view',
  },
  {
    title: 'Pages',
    icon: FileText,
    url: '/pages',
    permission: 'pages.view',
  },
  {
    title: 'Contacts',
    icon: Mail,
    url: '/contacts',
    permission: 'contacts.view',
  },
  {
    title: 'Master',
    icon: Settings,
    subItems: [
      {
        title: 'Industry',
        url: '/masters/industry',
        icon: Briefcase,
        permission: 'masters.industry.view'
      },
      {
        title: 'Revenue Goal',
        url: '/masters/revenue-goal',
        icon: Target,
        permission: 'masters.revenue_goal.view'
      },
      {
        title: 'Capability',
        url: '/masters/capability',
        icon: Zap,
        permission: 'masters.capability.view'
      },
      {
        title: 'Business Problem',
        url: '/masters/business-problem',
        icon: AlertCircle,
        permission: 'masters.business_problem.view'
      },
      {
        title: 'Lead Status',
        url: '/masters/lead-status',
        icon: Flame,
        permission: 'masters.lead_status.view'
      },
      {
        title: 'Lead Stage',
        url: '/masters/lead-stage',
        icon: GitBranch,
        permission: 'masters.lead_stage.view'
      },
      {
        title: 'Sales Stage',
        url: '/masters/sales-stage',
        icon: HandCoins,
        permission: 'masters.sales_stage.view'
      }
    ]
  },
  {
    title: 'Roles & Permissions',
    icon: ShieldCheck,
    url: '/roles',
    permission: 'roles.view',
  },
  {
    title: 'Admin Users',
    icon: Users,
    url: '/admin-users',
    permission: 'users.view',
  }
];

export const getFirstAllowedRoute = (permissions = []) => {
  const allowed = new Set(permissions);
  for (const item of MenuItems) {
    if (item.subItems) {
      const subItem = item.subItems.find((sub) => allowed.has(sub.permission));
      if (subItem) return subItem.url;
    } else if (allowed.has(item.permission)) {
      return item.url;
    }
  }
  return '/access-denied';
};

